import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReflectionState } from '../reducers/reflection.reducer';
import { REFLECTION_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ReflectionState>(REFLECTION_FEATURE_KEY);

export const selectLoading = (key: string) => createSelector(selectState, (state) => (state.items[key] ? state.items[key].loading : false));
export const selectLoaded = (key: string) => createSelector(selectState, (state) => (state.items[key] ? state.items[key].loaded : null));
export const selectReflection = (key: string) => createSelector(selectState, (state) => (state.items[key] ? state.items[key].data : null));
export const selectSaving = createSelector(selectState, (state) => state.saving);
export const selectSaved = createSelector(selectState, (state) => state.saved);
